import { useParams } from 'react-router-dom'
import classes from './NoticeEdit.module.scss'
import { useEffect, useState } from 'react'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { ja } from 'date-fns/locale' // 日本語ロケールをインポート
import { makeStyles } from '@material-ui/styles'
import {
  FormControlLabel,
  TextField,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { categories, publishStatuses } from '../../constants/notice'
import Editor from '../../components/notice/Editor'
import { Switch } from '@mui/material'
import { AttachFile } from '@material-ui/icons'
import DeleteIcon from '@material-ui/icons/Delete'
import { db, storage, FirebaseTimestamp } from '../../firebase'
import { collection, addDoc, updateDoc, getDocs } from 'firebase/firestore'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { formatDate } from '../../functions/utils/formatting'
import { uploadBase64ImagesAndReplaceUrls } from '../../functions/utils/imageUpload'
import Hero from '../../components/notice/Hero'
import FromToDatePickersForNotice from '../../components/Calendar/FromToDatePickersForNotice'
import DialogButton from '../../components/UIkit/DialogButton'
import { push } from 'connected-react-router'
import { useDispatch, useSelector } from 'react-redux'
import {
  hideLoadingAction,
  showLoadingAction,
} from '../../reducks/loading/actions'
import { getUserInfo } from '../../reducks/users/selectors'
import SelectBoxForNotice from '../../components/UIkit/SelectBoxForNotice'
const useStyles = makeStyles(() => ({
  datePicker: {
    width: (props) => (props.isMobile ? '80px' : '110px'),
    '& .MuiInputBase-input': {
      paddingTop: 0,
      paddingBottom: 0,
      height: '32px',
      fontSize: '14px',
      width: (props) => (props.isMobile ? '80px' : '110px'),
    },
    '& .MuiInputLabel-root': {
      fontSize: '14px',
      color: '#4dd0e1',
      width: (props) => (props.isMobile ? '80px' : '110px'),
    },
  },
  switchBase: {
    color: '#4dd0e1', // 未チェック時の色
    '&.Mui-checked': {
      color: '#4dd0e1', // チェック時の色
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#4dd0e1', // トラックの色
    },
  },
  label: {
    fontSize: '12px',
    color: '#4dd0e1',
  },
}))

const getEndDate = (date) => {
  const oneWeekLater = new Date(date)
  oneWeekLater.setDate(oneWeekLater.getDate() + 7)
  return oneWeekLater
}

const getStartDate = (date) => {
  return new Date()
}

const NoticeAdd = () => {
  const isMobile = useMediaQuery('(max-width:960px)')
  const userInfo = useSelector(getUserInfo)
  const styles = useStyles({ isMobile })
  const dispatch = useDispatch()
  //更新ユーザ
  const [updateUserEmail, setUpdateUserEmail] = useState(
    userInfo ? userInfo.email : ''
  )
  useEffect(() => {
    setUpdateUserEmail(userInfo.email)
  }, [userInfo.email])
  //タイトル
  const [title, setTitle] = useState('')
  //作成日
  const [createdAt, setCreatedAt] = useState(new Date())
  //カテゴリ
  const [category, setCategory] = useState('お知らせ')
  //公開区分
  const [publishStatus, setPublishStatus] = useState('公開')
  //通知
  const [isNotice, setIsNotice] = useState(true)
  //記事
  const [content, setContent] = useState('')
  const [noticeFromDate, setNoticeFromDate] = useState(getStartDate(new Date()))
  const [noticeToDate, setNoticeToDate] = useState(getEndDate(new Date()))
  //添付ファイル
  const [attachedFiles, setAttachedFiles] = useState([])

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files)
    const filesWithPreview = files.map((file) => {
      file.preview = URL.createObjectURL(file)
      return file
    })
    setAttachedFiles((prevFiles) => [...prevFiles, ...filesWithPreview])
  }

  const handleRemoveFile = (index) => {
    setAttachedFiles((prevFiles) => {
      URL.revokeObjectURL(prevFiles[index].preview)
      const newFiles = [...prevFiles]
      newFiles.splice(index, 1)
      return newFiles
    })
  }
  // const save = async () => {
  //   /**
  //    * firestorageに添付ファイルを保存する
  //    * 保存先のフォルダは`notices/attached/‘とする
  //    * 保存したファイルのURLを取得する
  //    * firestoreに記事情報を保存する
  //    * コレクション名は`notices`とする
  //    * フィールドは以下の通り
  //    * title: タイトル
  //    * createdDay: 作成日
  //    * catory: カテゴリ
  //    * publishStatus: 公開区分
  //    * notice: 通知
  //    * noticeFromDate: 通知開始日
  //    * noticeToDate: 通知終了日
  //    * content: 記事
  //    * attachedFiles: 添付ファイルのURL(配列)
  //    * addatchedFilesName: 添付ファイルの名前(配列)
  //    * createdAt: 作成日時
  //    * updatedAt: 更新日時
  //    * updateUser: 更新者
  //    */
  // };

  const save = async () => {
    try {
      dispatch(showLoadingAction('記事を保存中...'))

      // 先にドキュメントIDを生成（記事ID用）
      const docRef = await addDoc(collection(db, 'articles'), {})
      const articleId = docRef.id

      // エディタ内のbase64画像をStorageにアップロードしてURLに置き換え
      const processedContent = await uploadBase64ImagesAndReplaceUrls(
        content,
        articleId
      )

      // 添付ファイルをFirebase Storageにアップロード
      const uploadedFiles = await Promise.all(
        attachedFiles.map(async (file) => {
          const uniqueId =
            Date.now() + '_' + Math.random().toString(36).substr(2, 9)
          const uniqueName = `${uniqueId}_${file.name}`
          const storageRef = ref(storage, `notices/attached/${uniqueName}`)
          await uploadBytes(storageRef, file)
          const downloadURL = await getDownloadURL(storageRef)
          return {
            url: downloadURL,
            name: file.name,
          }
        })
      )

      const attachedFileURLs = uploadedFiles.map((file) => file.url)
      const attachedFileNames = uploadedFiles.map((file) => file.name)
      // usersコレクションから全ユーザーのメールアドレスを取得
      const usersSnapshot = await getDocs(collection(db, 'users'))
      const targetUsers = usersSnapshot.docs.map((doc) => ({
        email: doc.data().email,
        isOpened: false,
      }))

      // Firestoreに保存するデータを準備
      const data = {
        title,
        createdDay: formatDate(createdAt),
        category,
        publishStatus,
        notice: isNotice,
        noticeFromDate: formatDate(noticeFromDate),
        noticeToDate: formatDate(noticeToDate),
        content: processedContent, // 処理済みのcontentを使用
        attachedFiles: attachedFileURLs,
        attachedFilesName: attachedFileNames,
        createdAt: FirebaseTimestamp.now(),
        updatedAt: FirebaseTimestamp.now(),
        updateUser: updateUserEmail,
        targetUsers,
        id: articleId, // ドキュメントIDを追加
      }

      // 生成済みのドキュメントを更新
      await updateDoc(docRef, data)

      // 保存後の処理（例：メッセージ表示やページ遷移）
      dispatch(push('/notice/list'))
    } catch (error) {
      console.error('記事の保存中にエラーが発生しました:', error)
      alert('記事の保存中にエラーが発生しました。')
    } finally {
      dispatch(hideLoadingAction())
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ja}>
      <div className={classes.root}>
        <Hero title="新規投稿" />
        <div className={classes.main}>
          {/* タイトル */}
          <div className={classes.title}>
            <label className={classes.label} htmlFor="title">
              タイトル
            </label>
            <input
              className={classes.input}
              type="text"
              id="title"
              name="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className={classes.attributes}>
            <div className={classes.first}>
              {/* 日付 */}
              <DatePicker
                label={`日付`}
                value={createdAt}
                onChange={(e) => setCreatedAt(e)}
                inputFormat="yyyy/MM/dd" // フォーマットを指定
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={styles.datePicker}
                    style={{ width: isMobile ? '80px' : '110px' }}
                  />
                )}
                slotProps={{ calendarHeader: { format: 'YYYY年MM月' } }}
              />
              {/*カテゴリ */}
              <SelectBoxForNotice
                label={'カテゴリ'}
                options={categories}
                required={true}
                select={(e) => setCategory(e)}
                value={category}
                width="140px"
                height="50px"
                color="#4dd0e1"
                fontSize="14px"
                labelFontSize="14px"
              />
            </div>
            {/*公開設定 */}
            <div className={classes.second}>
              <div className={classes.publish}>
                <SelectBoxForNotice
                  label={'公開区分'}
                  options={publishStatuses}
                  required={true}
                  select={(e) => setPublishStatus(e)}
                  value={publishStatus}
                  width="120px"
                  height="50px"
                  color="#4dd0e1"
                  fontSize="14px"
                  labelFontSize="14px"
                />
              </div>
              <div className={classes.notice}>
                {/**お知らせ */}
                <FormControlLabel
                  label={<Typography className={styles.label}>通知</Typography>}
                  labelPlacement="start"
                  control={
                    <Switch
                      checked={isNotice}
                      onChange={(e) => setIsNotice(e.target.checked)}
                      sx={{
                        switchBase: styles.switchBase,
                      }}
                    />
                  }
                />
                <FromToDatePickersForNotice
                  setFromDate={setNoticeFromDate}
                  setToDate={setNoticeToDate}
                  fromDate={noticeFromDate}
                  toDate={noticeToDate}
                  disabled={!isNotice}
                />
              </div>
            </div>
          </div>
          <div className={classes.hr}></div>
          {/* 内容 */}

          <p className={classes.label}>記事</p>
          <div className={classes.contents}>
            <Editor content={content} setContent={setContent} />
          </div>
          <div className={classes.hr}></div>
          {/*添付ファイル*/}
          <div className={classes.attached}>
            <label className={classes.attachedLabel} htmlFor="attachFiles">
              <AttachFile className={classes.icon} />
              注文書（PDF）を添付
            </label>
            <input
              type="file"
              id="attachFiles"
              name="attachFiles"
              multiple
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
            <div className={classes.fileArea}>
              {attachedFiles.length > 0 && (
                <div className={styles.fileList}>
                  {attachedFiles.map((file, index) => (
                    <div key={index} className={classes.fileItem}>
                      <a
                        href={file.preview}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {file.name}
                      </a>
                      <button
                        onClick={() => handleRemoveFile(index)}
                        className={classes.icon}
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          {/* 保存ボタン */}
          <div className={classes.buttons}>
            <DialogButton label={'保存する'} onClick={save} mode="yes" />
            <DialogButton
              label={'一覧に戻る'}
              onClick={() => dispatch(push('/notice/list'))}
              mode="no"
            />
          </div>
        </div>
      </div>
    </LocalizationProvider>
  )
}

export default NoticeAdd
